import {
  Avatar,
  Button,
  Form,
  Input,
  notification,
  Select,
  Upload,
  Image,
  Tooltip,
} from "antd";
import { useState } from "react";
import { useUserMutation } from "../../api/Users";
import Loading from "../../components/Loading";
import { config } from "../../config";
import { ContentTitle } from "../../layout/ContentLayout";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import AntdImgCrop from "antd-img-crop";
import SubmitButton from "../../components/SubmitButton";
import { useImagePresignUrl } from "../../api/Images";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faUpload } from "@fortawesome/pro-solid-svg-icons";
import PhoneVerification from "../../components/PhoneVerification";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

dayjs.extend(timezone);

const { useForm } = Form;

const UserProfile = ({ user }) => {
  const [dirty, setDirty] = useState();
  const [submitting, setSubmitting] = useState();

  const [form] = useForm();

  const changeFields = () => {
    setDirty(true);
  };

  useState(() => {
    if (!user?.Timezone) {
      user.Timezone = dayjs.tz.guess();
    }
  }, []);

  const userMutation = useUserMutation(user?.UserId);
  const submit = () => {
    let values = form.getFieldsValue(null, (meta) => meta.touched);
    setSubmitting(true);

    userMutation
      .mutateAsync(values)
      .then(() => {
        notification.success({
          message: "Profile Update",
          description: "Your profile was updated",
        });
        setDirty(false);
      })
      .finally(() => setSubmitting(false));
  };

  const presignUrl = useImagePresignUrl();
  const changeImage = (img) => {
    setSubmitting(true);
    presignUrl
      .mutateAsync({
        entityId: user?.UserId,
        entityType: "userAvatar",
        name: img.file.name,
        imageType: "image/jpg",
      })
      .then((r) => {
        const { url, imageKey } = r;
        axios.put(url, img.file).then(() => {
          userMutation.mutateAsync({ Avatar: imageKey }).then(() =>
            notification.success({
              message: "Image uploaded",
              description: "Your profile photo has been changed",
            })
          );
        });
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return user ? (
    <>
      <ContentTitle>Profile</ContentTitle>
      <Form
        form={form}
        initialValues={user}
        layout="vertical"
        onFieldsChange={changeFields}
        onFinish={submit}
      >
        <Form.Item>
          <AntdImgCrop aspect={1}>
            <Upload
              beforeUpload={(file) => {
                return false;
              }}
              showUploadList={false}
              onChange={(file) => changeImage(file)}
              multiple={false}
            >
              <Avatar
                shape="square"
                size={100}
                src={user?.Avatar && `${config.imageUrl}/${user.Avatar}`}
                style={{ border: "2px dashed #dedede", padding: "3px" }}
                icon={<FontAwesomeIcon icon={faUpload} />}
              />
            </Upload>
          </AntdImgCrop>
        </Form.Item>
        <Form.Item name="FirstName" label="First Name">
          <Input />
        </Form.Item>
        <Form.Item name="LastName" label="Last Name">
          <Input />
        </Form.Item>
        <Form.Item name="Phone" label="Phone Number">
          <Input
            addonBefore={
              user?.PhoneVerified ? (
                <Tooltip title="Phone number verified">
                  <FontAwesomeIcon icon={faCheck} />
                </Tooltip>
              ) : (
                <Tooltip title="Phone number not verified">
                  <FontAwesomeIcon icon={faTriangleExclamation} />
                </Tooltip>
              )
            }
          />
        </Form.Item>
        {user?.Phone && !user?.PhoneVerified && (
          <Form.Item style={{ textAlign: "right" }}>
            <PhoneVerification user={user} />
          </Form.Item>
        )}
        <Form.Item name="Timezone" label="Timezone">
          <Select
            options={Intl.supportedValuesOf("timeZone").map((t) => ({
              label: t,
              value: t,
            }))}
            showSearch
          />
        </Form.Item>
        <Form.Item name="Email" label="Email">
          <Input disabled />
        </Form.Item>
        <Form.Item>
          <SubmitButton disabled={!dirty} submitting={submitting}>
            Update
          </SubmitButton>
        </Form.Item>
      </Form>
    </>
  ) : (
    <Loading />
  );
};

export default UserProfile;
